export const tr = {
    'create-by': 'Şunun bazında oluştur',
    'create-tooltip': 'Maksimum 30 negatif anahtar sözcük grubu dizisi oluşturabilirsiniz',
    'create-tooltip-disabled': 'Dizi oluşturma yetkisi yok',
    delete: 'Sil',
    'delete-tooltip': 'Silinmeden önce tüm gruplardan negatif anahtar sözcük gruplarının dizisini ayırın',
    'delete-tooltip-disabled': 'Dizi silme yetkisi yok',
    edit: 'Düzelt',
    'editable-tooltip': 'Dizi düzenleme yetkisi yok'
};
